module.exports = __webpack_public_path__ + "img/telao-black2.7292456f.jpg";